import { takeLatest, put, call } from 'redux-saga/effects';

import { storage } from '@commons';
import {
  NEW_FILTER_NEXT_PAGE_PRODUTO_INSUMO,
  NEW_FILTER_NEXT_PAGE_PRODUTO_INSUMO_PENDING,
  NEW_FILTER_NEXT_PAGE_PRODUTO_INSUMO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_PRODUTO_INSUMO_FAILURE,
} from '../actionTypes';
import { CONST_FILTER_PRODUTO_INSUMO } from '@commons/consts';
import { filterProdutoInsumo } from '../service';
import { CONFIG_SESSION } from '@handler/common/startSession';

function* sagaNewFilterNextPageProdutoInsumo(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_PRODUTO_INSUMO_PENDING });

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_PRODUTO_INSUMO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PRODUTO_INSUMO)) : null;

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    const list = yield call(filterProdutoInsumo, idFazenda, `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`);

    sessionStorage.setItem(CONST_FILTER_PRODUTO_INSUMO, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_PRODUTO_INSUMO_SUCCESS, list: list, filter: newFilter
    });
  } catch (error) {
    yield put({ type: NEW_FILTER_NEXT_PAGE_PRODUTO_INSUMO_FAILURE });
  }
}

export default function* watchNewFilterNextPageProdutoInsumo() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_PRODUTO_INSUMO, sagaNewFilterNextPageProdutoInsumo);
}
